<template>
    <div>
        <v-layout column class="justify-center align-center" style="background-color: #2e3344" :style="setHeaderHeight">
            <v-layout row class="justify-center align-center" style="width: 90%">
                <v-btn icon class="mx-1" @mouseup.left="$emit('update')">
                    <v-icon class="white--text">east</v-icon>
                </v-btn>
                <v-flex class="white--text text-sm-center">{{ $t("lang.knowledge_center") }}</v-flex>
                <v-btn icon class="mx-1" @mouseup.left="toggleSearch()">
                    <v-icon class="white--text">search</v-icon>
                </v-btn>
            </v-layout>
            <v-layout column :style="{ width: '90%', 'margin-bottom': '10px' }" v-if="showInput">
                <v-form @submit.prevent="getArticles()">
                    <v-text-field
                        v-focus="showInput"
                        v-model="localSearch"
                        :label="$t('lang.search_dots')"
                        :value="searchInput"
                        @input="updateSearch(localSearch)"
                        style="caret-color: white !important"
                        class="white--text pa-0 ma-0"
                        maxLength="255"
                        single-line
                        clearable
                        @mouseup.left="clearSearchInput()"
                        dark
                    ></v-text-field>
                </v-form>
                <v-btn block depressed class="py-2" @mouseup.left="!localSearch || localSearch.length == 0 ? null : getArticles()">
                    {{ $t("lang.search") }}
                </v-btn>
            </v-layout>
        </v-layout>
        <v-layout
            v-if="help_articles && help_articles.length > 0 && !sidebar_loader"
            :style="{ 'overflow-y': 'scroll !important', height: setScrollBarHeight }"
            class="scrollbar_custom px-3 pb-2"
            column
        >
            <v-flex avatar v-for="(article, index) in help_articles" style="flex-grow: 0" :key="index" :class="{ 'mt-3': index == 0 }">
                <v-layout column>
                    <v-flex
                        style="flex-grow: 0"
                        @mouseup.left="setActiveArticle(article)"
                        class="clickable help-article"
                        :pt-3="index > 0"
                        :pb-3="index != help_articles.length - 1"
                    >
                        <div class="mb-1 caption">
                            <b>{{ article.display_name }}</b>
                        </div>
                        <div class="mb-2 title">
                            <b>{{ article.title }}</b>
                        </div>
                        <div class="font-italic body-1">
                            {{ `${$t("lang.date_last_updated")}  ${article.date_created ? formatedDate(article.date_created) : "---"}` }}
                        </div>
                    </v-flex>
                    <v-divider class="my-2" v-if="index != help_articles.length - 1"></v-divider>
                </v-layout>
            </v-flex>
            <v-layout row mt-3 v-if="!sidebar_loader && isInternalUser()">
                <v-flex xs6>
                    <v-btn color="primary" @mouseup.left="routeUser(route, 'add')">
                        {{ $t("lang.add_article") }}
                    </v-btn>
                </v-flex>
                <v-flex xs6>
                    <v-btn color="primary" @mouseup.left="routeUser(route, 'edit')">
                        {{ $t("lang.edit_articles") }}
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-layout>
        <div v-else style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; height: 100%">
            <app-section-loader :status="sidebar_loader"></app-section-loader>
            <div v-if="!sidebar_loader" class="w-80 text-center">
                <b>{{ $t("lang.no_articles_available") }}</b>
            </div>
            <v-btn v-if="!sidebar_loader && isInternalUser()" class="mt-3" color="primary" @mouseup.left="routeUser(route, 'add')">
                {{ $t("lang.add_article") }}
            </v-btn>
        </div>
        <bc-dialog v-model="knowledgeArticle" :max-width="$bp.lgAndUp ? '900px' : dialogWidth" :persistent="false">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.knowledge_center") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="knowledgeArticle"
                        :dialog-status="knowledgeArticle"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-form>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <div :class="$bp.lgAndUp ? 'display-1' : 'headline'">{{ active_article.title | capitalize }}</div>
                            </v-flex>
                            <v-flex xs12>
                                <div class="font-italic">
                                    {{ `${$t("lang.date_last_updated")} ${active_article.date_created ? formatedDate(active_article.date_created) : "---"}` }}
                                </div>
                            </v-flex>
                            <v-flex xs12>
                                <div
                                    v-html="active_article.article"
                                    style="white-space: pre-line; display: inline-block"
                                    :style="{ 'max-width': $bp.lgAndUp ? '900px' : dialogWidth }"
                                ></div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <bc-btn-feedback-actions></bc-btn-feedback-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="knowledgeArticle = false">{{ $t("lang.close") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import BcBtnFeedbackActions from "../Buttons/BcBtnFeedbackActions";

export default {
    props: ["route", "chatSidebar", "search", "getArticles", "searchInput", "updateSearch"],
    data() {
        return {
            showInput: false,
            knowledgeArticle: false,
            active_article: {
                title: "",
                article: "",
                date_created: "",
            },
            settings: {
                maxScrollbarLength: 160,
            },
            localSearch: "",
        };
    },
    watch: {
        chatSidebar() {
            if (!this.chatSidebar && this.localSearch == "") this.showInput = false;
        },
        localSearch() {
            if (!(this.localSearch && this.localSearch.length > 0)) this.getArticles();
        },
    },
    computed: {
        ...mapGetters(["help_articles", "sidebar_loader"]),
        setScrollBarHeight() {
            if (!this.showInput && !this.$bp.xs) {
                return "calc(100vh - 64px)";
            } else if (this.showInput && !this.$bp.xs) {
                return "calc(100vh - 167px)";
            } else if (!this.showInput && this.$bp.xs) {
                return "calc(100vh - 56px)";
            } else if (this.showInput && this.$bp.xs) {
                return "calc(100vh - 159px)";
            }
        },
        setHeaderHeight() {
            //if mobile return this
            if (this.$bp.xs) return { height: this.showInput ? "auto" : "56px", "padding-top": this.showInput ? "6px" : null };
            //else return this
            return { height: this.showInput ? "auto" : "64px", "padding-top": this.showInput ? "8px" : null };
        },
        dialogWidth() {
            return this.$bp.xs ? `${this.$bp.width}px` : `${this.$bp.width - 48}px`; // need to account for x-padding added to dialog while not mobile
        },
    },
    methods: {
        routeUser(route, method) {
            this.$store.commit("toggleHelpArticleMenuHandler", false);
            this.$store.commit("updateCurrentRoute", route);
            localStorage.setItem("currentRoute", route);
            if (method == "add") {
                this.$router.push({ name: "help_articles_add" });
            } else if (method == "edit") {
                this.$router.push({ name: "help_articles" });
            }
        },
        setActiveArticle(article) {
            //TODO: scroll back to top of article
            this.active_article = article;
            this.knowledgeArticle = true;
        },
        toggleSearch() {
            this.showInput = !this.showInput;
        },
        formatedDate(date) {
            return date.split(" ")[0];
        },
        clearSearchInput() {
            this.$nextTick(() => {
                this.localSearch = "";
            });
        },
    },
    components: {
        BcBtnFeedbackActions,
    },
};
</script>
